/** @format */

import React from 'react'
import { _$, Step, Steps } from '@king-design/react'
import styled from 'styled-components'
import CodeDisplay from '../../../../components/CodeDisplay'
import { CopyButton } from 'src/components'

const Langfuse: React.FC<{
  className?: string
  visible?: boolean
  publicKey: string
  secretKey: string
  region: string
}> = ({ className, visible, publicKey, secretKey, region }) => {
  const installCommand = "pip install 'langfuse>=3.7.0'"
  const codeExample = `# 1. 初始化 Langfuse CallbackHandler (从环境变量读取配置)
# 需要设置: LANGFUSE_PUBLIC_KEY, LANGFUSE_SECRET_KEY, LANGFUSE_HOST或者手动设置参数
from langfuse import get_client,Langfuse
from langfuse.langchain import CallbackHandler

#langfuse = get_client()
langfuse = Langfuse(
    public_key="publicKey_replace",
    secret_key="secretKey_replace",
    host="https://${region}.otlp.ksyun.com:4318/langfuse",
)
langfuse_handler = CallbackHandler()

def run_agent(user_input: str, thread_id: str = "default") -> str:
    logger.info(f"=== 新请求: {user_input[:50]}... ===")

    # 2. 在 invoke 时传入 callbacks，自动追踪整个 Graph
    config = {
        "configurable": {"thread_id": thread_id},
        "callbacks": [langfuse_handler] if langfuse_handler else [],
        "metadata": {
            "langfuse_session_id": thread_id,
            "langfuse_tags": ["langgraph-agent"],
        },
    }

    initial_state = {
        "messages": [HumanMessage(content=user_input)],
        "next_step": "",
        "tool_result": "",
    }

    result = agent.invoke(initial_state, config=config)
    return result["messages"][-1].content
# ── Run ───────────────────────────────────────────────────────────────
  if __name__ == "__main__":
    result = agent.invoke(
        {"messages": [HumanMessage(content="武汉今天天气怎么样？")]},
        config={
            "callbacks": [langfuse_handler],
            "metadata": {
                # 设置session id
                "langfuse_session_id": "lf-session-001",
                "langfuse_user_id": "lf-user-001",
            },
        },
    )
  `

  return (
    <Steps className={className} vertical type="simple" value={3}>
      <Step title={_$('一、安装Langfuse SDK')}>
        <>
          <p>{_$('通过pip安装Langfuse SDK，要求python版本大于等于3.9')}</p>
          <CodeDisplay
            content={installCommand}
            language="shell"
            lineNumbers
            refreshTrigger={visible}
            height={40}
          />
        </>
      </Step>
      <Step title={_$('二、参考下面的代码示例，正确设置public key、secret key和host')}>
        <>
          <p className="sub-title">
            <span>LANGFUSE_PUBLIC_KEY：</span> ********
            <CopyButton text={publicKey} />
          </p>
          <p className="sub-title">
            <span>LANGFUSE_SECRET_KEY：</span> ********
            <CopyButton text={secretKey}></CopyButton>
          </p>
          <p className="sub-title">{_$('LANGFUSE_HOST')}：</p>
          <p style={{ marginLeft: 8 }}>
            {_$('公网地址')}：<span>https://{region}.otlp.ksyun.com:4318</span>
            <CopyButton text={`https://${region}.otlp.ksyun.com:4318`} />
          </p>
          <p style={{ marginLeft: 8 }}>
            {_$('内网地址')}：<span>http://{region}.internal.otlp.ksyun.com:4318</span>
            <CopyButton text={`http://${region}.internal.otlp.ksyun.com:4318`} />
          </p>
          <CodeDisplay
            content={
              publicKey && secretKey
                ? codeExample
                    .replace(/publicKey_replace/g, '********')
                    .replace(/secretKey_replace/g, '********')
                : codeExample
            }
            copyContent={
              publicKey && secretKey
                ? codeExample
                    .replace(/publicKey_replace/g, publicKey)
                    .replace(/secretKey_replace/g, secretKey)
                : codeExample
            }
            language="python"
            height={620}
            lineNumbers
            refreshTrigger={visible}
          />
        </>
      </Step>
      <Step title={_$('三、在云监控中观测是否有trace上报')} />
    </Steps>
  )
}

export default styled(Langfuse)``
